export const LOAD_ALL_LABS = 'LOAD_ALL_LABS'
export const LOAD_ALL_EXAMS = 'LOAD_ALL_EXAMS'
export const LOAD_STUDENTS_FOR_EXAM = 'LOAD_STUDENTS_FOR_EXAM'
export const CREATE_LAB = 'CREATE_LAB'
export const DELETE_LAB = 'DELETE_LAB'
export const UPDATE_LAB = 'UPDATE_LAB'
export const BULK_UPDATE_LAB_VISIBILITY = 'BULK_UPDATE_LAB_VISIBILITY'
export const REORDER_LABS_SUCCESS = 'REORDER_LABS_SUCCESS'
export const START_EXAM = 'START_EXAM'
export const END_EXAM = 'END_EXAM'
export const RESET_EXAM = 'RESET_EXAM'
export const VISIBILITY_EXAM = 'VISIBILITY_EXAM'
export const LOAD_ALL_ACTIVITIES = 'LOAD_ALL_ACTIVITIES'
export const CREATE_ACTIVITY = 'CREATE_ACTIVITY'
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY'
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY'
export const REORDER_ACTIVITIES_SUCCESS = 'REORDER_ACTIVITIES_SUCCESS'
export const LOAD_LABS_PAGINATED = 'LOAD_LABS_PAGINATED'
//Data is already there, no need to do a backend call here